import React, { useEffect } from "react";
import { getData } from "../api/controller/Controller";
import { history } from "../history";
import { logout } from "../api/controller/AuthController";
import { UserData } from "@src/hooks/context/user/userContext";

const withAccessControl = (
  WrappedComponent,
  requiredAccess,
  requiredAccess2,
  typeMenu
) => {
  const { state } = UserData();

  const WithAccessControl = (props) => {
    const checkUserAccess = async () => {
      try {
        const menu = await getData({ id: state.userRole?.id }, "role/access");
        if (menu.code === 200) {
          return menu.data.menu.map(({ id, navLink, type, id_foreign }) => ({
            id,
            link: navLink,
            type,
            id_foreign,
          }));
        } else if (menu.code === 401) {
          await logout();
          history.push("/");
        } else {
          throw menu;
        }
      } catch (error) {
        if (error.code === 401 || error.message.includes("Unauthenticated")) {
          await logout();
          history.push("/");
        }
        throw new Error(error.message);
      }
    };

    useEffect(() => {
      const checkAccess = async () => {
        try {
          const hasAccess = await checkUserAccess();
          const hasRequiredAccess = hasAccess?.some((item) =>
            typeMenu
              ? (item.link === requiredAccess ||
                  item.link === requiredAccess2) &&
                item.id_foreign
              : item.link === requiredAccess || item.link === requiredAccess2
          );

          if (!hasRequiredAccess) {
            history.replace("/unauthorized");
          }
        } catch (error) {
          console.error(error);
        }
      };

      checkAccess();
      // eslint-disable-next-line
    }, []);

    return <WrappedComponent {...props} />;
  };

  return WithAccessControl;
};

export default withAccessControl;
